import { language } from '../utils/language';

export const BUILDING_TYPE = {
  BLOCK: language.label.block,
  BUILDING: language.label.building,
  AREA: language.label.area,
};

export const BUILDING_TEXT = 'BUILDING';
